module.exports = __webpack_public_path__ + "img/station-icon_3.92c18e82.png";